export const SORTABLE = {
  ENTITY_TYPE: {
    INBOX_TASK: 'INBOX_TASK',
    KANBAN_ITEM: 'KANBAN_ITEM',
  },
  SCOPE_TYPE: {
    USER: 'USER',
  },
} as const;

